import { COTE_MAX, enAdresseDeDonnees, reduitLImage } from './image';

/**
 * Justificatif d'une dépense : le ticket, la facture ou le reçu.
 *
 * Il voyage encodé dans le corps JSON de la dépense, et le serveur y pose une
 * limite. Une photo de téléphone la dépasse sans peine : sans réduction, la
 * dépense partait avec sa pièce et revenait refusée, au moment précis où l'on
 * voulait la classer. La réduction se fait donc ici, avant l'envoi.
 */

/** Un mégaoctet de fichier, avant encodage. */
const OCTETS_MAX = 1024 * 1024;

/**
 * Longueur maximale de la pièce encodée.
 *
 * L'encodage produit quatre caractères pour trois octets, plus le préfixe
 * `data:image/jpeg;base64,` que le navigateur fabrique. Le calcul reprend
 * celui du serveur : les deux doivent dire la même chose, sinon l'un refuse ce
 * que l'autre accepte.
 */
export const LIMITE_JUSTIFICATIF = Math.floor((OCTETS_MAX + 2) / 3) * 4 + 64;

/** Exprime une taille en mégaoctets, à la suisse. */
const enMo = (octets) => (octets / (1024 * 1024)).toFixed(1).replace('.', ',');

/**
 * Prépare un justificatif pour l'envoi.
 *
 * @param {Blob} fichier fichier choisi ou photographié
 * @returns {Promise<{piece: string, pieceNom: string, pieceMime: string}>}
 *   la pièce prête à joindre
 * @throws {Error} si la pièce reste trop lourde après réduction
 */
export async function prepareLeJustificatif(fichier) {
  const reduit = await reduitLImage(fichier, COTE_MAX);
  const piece = await enAdresseDeDonnees(reduit);
  if (piece.length > LIMITE_JUSTIFICATIF) {
    throw new Error(
      `Ce justificatif pèse ${enMo(reduit.size)} Mo, au-delà du mégaoctet admis. ` +
        'Photographiez-le d’un peu plus loin, ou joignez un PDF plus léger.',
    );
  }
  return {
    piece,
    pieceNom: fichier.name || 'justificatif',
    pieceMime: reduit.type || fichier.type || '',
  };
}
